(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@xfe-team/universal-auth", [], factory);
	else if(typeof exports === 'object')
		exports["@xfe-team/universal-auth"] = factory();
	else
		root["@xfe-team/universal-auth"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 